{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-github-oauth-ui",
  "version": "5.0.3",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "cli": "bash run cli",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest --watch false",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^2.0.3",
    "@octokit/request": "^6.2.1",
    "chalk": "^4.1.2",
    "dotenv": "^16.0.1",
    "express": "^4.18.1",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.6",
    "octokit": "^2.0.7",
    "open": "^8.4.0",
    "ow": "^0.28.1",
    "query-string": "^7.1.1"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.13",
    "@types/global-agent": "^2.1.1",
    "@types/lodash": "^4.14.184",
    "@types/memory-cache": "^0.2.2",
    "@types/minimist": "^1.2.2",
    "@types/node": "^16.11.56",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^10.5.2",
    "browserslist": "^4.21.3",
    "c8": "^7.12.0",
    "core-js": "^3.25.0",
    "nodemon": "^2.0.19",
    "parcel": "~2.4.1",
    "prettier": "^2.7.1",
    "process": "^0.11.10",
    "release-it": "^15.4.0",
    "timekeeper": "^2.2.0",
    "type-fest": "^2.19.0",
    "typescript": "^4.8.2",
    "verdaccio": "^5.14.0",
    "verdaccio-htpasswd": "^10.5.0",
    "vite": "^3.0.9",
    "vitest": "^0.22.1"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "engines": {
    "node": "^16"
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  },
  "packageManager": "yarn@3.2.1"
}
